import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { getRestaurantTags } from 'restaurantAdmin/restaurants/apiHelpers';
import { useQuery } from '@tanstack/react-query';

export const useGuestTags = () => {
  const { id: restaurantId } = useRestaurant();

  return useQuery({
    queryKey: ['restaurants', restaurantId, 'guestTags'],
    queryFn: async () => getRestaurantTags(restaurantId),
    initialData: [],
    select: (data) => data.sort((a, b) => a.title.localeCompare(b.title)),
  });
};
